import * as syllabusApi from 'services/syllabusApi';

export const UPLOAD_SYLLABUS_REQUEST = 'UPLOAD_SYLLABUS_REQUEST';
export const UPLOAD_SYLLABUS_SUCCESS = 'UPLOAD_SYLLABUS_SUCCESS';
export const UPLOAD_SYLLABUS_FAILURE = 'UPLOAD_SYLLABUS_FAILURE';

export const CREATE_DRAFT_SYLLABUS_REQUEST = 'CREATE_DRAFT_SYLLABUS_REQUEST';
export const CREATE_DRAFT_SYLLABUS_SUCCESS = 'CREATE_DRAFT_SYLLABUS_SUCCESS';
export const CREATE_DRAFT_SYLLABUS_FAILURE = 'CREATE_DRAFT_SYLLABUS_FAILURE';

export const GET_SYLLABUS_REQUEST = 'GET_SYLLABUS_REQUEST';
export const GET_SYLLABUS_SUCCESS = 'GET_SYLLABUS_SUCCESS';
export const GET_SYLLABUS_FAILURE = 'GET_SYLLABUS_FAILURE';

export const UPDATE_SYLLABUS_SETTINGS_REQUEST =
  'UPDATE_SYLLABUS_SETTINGS_REQUEST';
export const UPDATE_SYLLABUS_SETTINGS_SUCCESS =
  'UPDATE_SYLLABUS_SETTINGS_SUCCESS';
export const UPDATE_SYLLABUS_SETTINGS_FAILURE =
  'UPDATE_SYLLABUS_SETTINGS_FAILURE';

export const UPDATE_SYLLABUS_STATUS_REQUEST = 'UPDATE_SYLLABUS_STATUS_REQUEST';
export const UPDATE_SYLLABUS_STATUS_SUCCESS = 'UPDATE_SYLLABUS_STATUS_SUCCESS';
export const UPDATE_SYLLABUS_STATUS_FAILURE = 'UPDATE_SYLLABUS_STATUS_FAILURE';
export const UPDATE_SYLLABUS_ROW_STATUS = 'UPDATE_SYLLABUS_ROW_STATUS';
export const UPDATE_SYLLABUS_READING_STATUS = 'UPDATE_SYLLABUS_READING_STATUS';

export const uploadSyllabus = (courseId, file) => async (dispatch) => {
  dispatch({ type: UPLOAD_SYLLABUS_REQUEST });
  try {
    const data = await syllabusApi.uploadSyllabus(courseId, file);
    dispatch({ type: UPLOAD_SYLLABUS_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: UPLOAD_SYLLABUS_FAILURE, error: error.message });
    throw error;
  }
};

export const createDraftSyllabus = (courseId, rows) => async (dispatch) => {
  dispatch({ type: CREATE_DRAFT_SYLLABUS_REQUEST });
  try {
    const data = await syllabusApi.createDraftSyllabus(courseId, rows);
    dispatch({ type: CREATE_DRAFT_SYLLABUS_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: CREATE_DRAFT_SYLLABUS_FAILURE, error: error.message });
    throw error;
  }
};

export const getSyllabus = (courseId) => async (dispatch) => {
  dispatch({ type: GET_SYLLABUS_REQUEST });
  try {
    const data = await syllabusApi.getSyllabus(courseId);
    dispatch({ type: GET_SYLLABUS_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: GET_SYLLABUS_FAILURE, error: error.message });
    throw error;
  }
};

export const updateSyllabusSettings =
  (courseId, settings) => async (dispatch) => {
    dispatch({ type: UPDATE_SYLLABUS_SETTINGS_REQUEST });
    try {
      const data = await syllabusApi.updateSyllabusSettings(courseId, settings);
      dispatch({ type: UPDATE_SYLLABUS_SETTINGS_SUCCESS, payload: data });
      return data;
    } catch (error) {
      dispatch({ type: UPDATE_SYLLABUS_SETTINGS_FAILURE, error: error.message });
      throw error;
    }
  };

export const updateSyllabusStatus = (courseId, status) => async (dispatch) => {
  dispatch({ type: UPDATE_SYLLABUS_STATUS_REQUEST });
  try {
    const data = await syllabusApi.updateSyllabusStatus(courseId, status);
    dispatch({ type: UPDATE_SYLLABUS_STATUS_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: UPDATE_SYLLABUS_STATUS_FAILURE, error: error.message });
    throw error;
  }
};

export const addSyllabusRow = (courseId, row) => async () => {
  return await syllabusApi.addSyllabusRow(courseId, row);
};

export const updateSyllabusRow = (courseId, rowId, row) => async () => {
  return await syllabusApi.updateSyllabusRow(courseId, rowId, row);
};

export const deleteSyllabusRow = (courseId, rowId) => async () => {
  return await syllabusApi.deleteSyllabusRow(courseId, rowId);
};

export const deleteSyllabus = (courseId) => async () => {
  return await syllabusApi.deleteSyllabus(courseId);
};

export const updateSyllabusRowStatus =
  (courseId, rowId, status) => async (dispatch) => {
    const data = await syllabusApi.updateRowStatus(courseId, rowId, status);
    dispatch({
      type: UPDATE_SYLLABUS_ROW_STATUS,
      payload: { rowId, status },
    });
    return data;
  };

export const updateSyllabusReadingStatus =
  (courseId, rowId, readingId, status) => async (dispatch) => {
    const data = await syllabusApi.updateReadingStatus(
      courseId,
      rowId,
      readingId,
      status,
    );

    dispatch({
      type: UPDATE_SYLLABUS_READING_STATUS,
      payload: { rowId, readingId, status },
    });

    return data;
  };
